import { Url } from '../shared/Url';
import Post from '../shared/Post';
import { cookieData } from '../funciones/ConsultaUser';
import { requerido, numero, email } from './Validaciones'

export const consultaPreferencias = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
        }

        Post(`${Url}consultaPreferencias`, Content, (resp) => {
            let data = JSON.parse(resp);
            let autoridades = data[0];
            let preferencias = data[1][0];
            let autTypes = data[2];
            let cortes = data[3];
            let contenido= [];

            for (let i in autTypes) {
                contenido.push(
                    { value: autTypes[i].id, label: autTypes[i].type_name }
                )
            }

            respuesta([autoridades, preferencias, contenido, cortes])
        });
    });
}

export const AddPeriodo = (mes, ano, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            mes: mes,
            year: ano
        }

        Post(`${Url}addPeriodo`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data)
        });
    });
}

export const GuardarAut = (campos, respuesta) => {
    let errores = 0;
    let nameErr = [];
    let states = [];

    let mensaje = [{
        status: "error",
        mensaje: "No se pudo guardar la información. Revisa los errores encontrados para continuar"
    }];

    /* Validaciones */
    requerido(errores, campos.cedula.text, "", "", "", "La Cédula de Identidad Es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.nombre.text, "", "", "", "El Nombre Es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.apellido.text, "", "", "", "El Apellido Es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.valorAutTypes.value, "", "", "", "Debes seleccionar el Tipo de Autoridad", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    if (errores === 0){
        cookieData((cookie) => {
            let Content = {
                uId: cookie[1],
                campos: campos
            }

            Post(`${Url}addAutoridades`, Content, (resp) => {

                mensaje = [{
                    status: "info",
                    mensaje: "Se ha guardado correctamente la Autoridad Educativa"
                }];
                
                respuesta([states, mensaje, errores, nameErr])
            });
        });
    }else{
        respuesta([states, mensaje, errores, nameErr])
    }
}

export const UpdAut = (id, campos, respuesta) => {
    let errores = 0;
    let nameErr = [];
    let states = [];

    let mensaje = [{
        status: "error",
        mensaje: "No se pudo actualizar la información. Revisa los errores encontrados para continuar"
    }];

    /* Validaciones */
    requerido(errores, campos.cedula.text, "", "", "", "La Cédula de Identidad Es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.nombre.text, "", "", "", "El Nombre Es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.apellido.text, "", "", "", "El Apellido Es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });
    requerido(errores, campos.valorAutTypes.value, "", "", "", "Debes seleccionar el Tipo de Autoridad", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    if (errores === 0){
        cookieData((cookie) => {
            let Content = {
                uId: cookie[1],
                campos: campos,
                id: id
            }

            Post(`${Url}updAutoridades`, Content, (resp) => {
                mensaje = [{
                    status: "info",
                    mensaje: "Se han actualizado correctamente los datos de la Autoridad Educativa"
                }];
                
                respuesta([states, mensaje, errores, nameErr])
            });
        });
    }else{
        respuesta([states, mensaje, errores, nameErr])
    }
}

export const DeleteAut = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            id: id
        }

        Post(`${Url}delAutoridades`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data)
        });
    });
}

export const DeletePeriodo = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            idPeriodo: id
        }

        Post(`${Url}delPeriodo`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data)
        });
    });
}

export const DeleteTmp = (respuesta) => {
    let Content = ""

    Post(`${Url}deleteTmp`, Content, (resp) => {
        let data = JSON.parse(resp)
        respuesta(data)
    });
}

export const Guardar = (campos, respuesta) => {

    let errores = 0;
    let nameErr = [];
    let states = [];

    let mensaje = [{
        status: "error",
        mensaje: "No se pudo guardar la información. Revisa los errores encontrados para continuar"
    }];

    /* Validaciones */
    requerido(errores, campos.instituto, "", "", "", "El campo Nombre de la Institución es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.instituto_tlf1, "", "", "", "El campo Teléfono 1 es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.instituto_tlf2, "", "", "", "El campo Teléfono 2 es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.instituto_tlf3, "", "", "", "El campo Teléfono 3 es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.instituto_dir, "", "", "", "El campo Dirección es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.instituto_email, "", "", "", "El campo Email es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    numero(errores, campos.instituto_tlf1, "", "", "El campo Teléfono 1 debe contener solo números", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    numero(errores, campos.instituto_tlf2, "", "", "El campo Teléfono 2 debe contener solo números", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    numero(errores, campos.instituto_tlf3, "", "", "El campo Teléfono 3 debe contener solo números", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    email(errores, campos.instituto_email, "", "", "", "El campo Email debe tener un formato correcto", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    /* Validaciones de la Inscripción */
    requerido(errores, campos.min_uc, "", "", "", "El campo Mínimo de Unidades de Cŕedito es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.max_uc, "", "", "", "El campo Máximo de Unidades de Cŕedito es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.min_mate, "", "", "", "El campo Mínimo de Materias a Inscribir es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.max_mate, "", "", "", "El campo Máximo de Materias a Inscribir es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    /* Validaciones de los porcentajes */
    
    let cortes = campos.cortes;
    let porcentaje = 0;

    for (let i = 0; i < cortes; i++){
        let corteN = `p_corte_${i + 1}`;
        let colCorteN = `col_p_corte_${i + 1}`;
        porcentaje += parseInt(campos[corteN]);

        requerido(errores, campos[corteN], "", "", "", `El campo Porcentaje del Corte ${i + 1} es Obligatorio`, (resp) => {
            errores = resp[1];
            states.push(resp[0][0])
            nameErr.push(resp[2])
        });

        numero(errores, campos[corteN], "", "", `El campo Porcentaje del Corte ${i + 1} debe contener solo números`, (resp) => {
            errores = resp[1];
            states.push(resp[0][0])
            nameErr.push(resp[2])
        });

        requerido(errores, campos[colCorteN], "", "", "", `Debes específicar la Columna para el Corte ${i + 1}`, (resp) => {
            errores = resp[1];
            states.push(resp[0][0])
            nameErr.push(resp[2])
        });

    }

    if ( porcentaje < 100 || porcentaje > 100) {
        errores ++;
        nameErr.push("El porcentaje de la Evaluación debe sumar 100%")
    }

    if (errores === 0){
        cookieData((cookie) => {

            let contenido = campos;
            let nc = parseInt(campos.cortes);

            let updContenido = (num, i, campo1, campo2, respuesta) => {
                if (nc < num ) {
                    if (i === campo1) respuesta("");
                    if (i === campo2) respuesta("");
                }
            }

            for (let i in contenido) {
                updContenido(5, i, "p_corte_5", "col_p_corte_5", (resp) => { contenido[i] = resp })
                updContenido(4, i, "p_corte_4", "col_p_corte_4", (resp) => { contenido[i] = resp })
                updContenido(3, i, "p_corte_3", "col_p_corte_3", (resp) => { contenido[i] = resp })
                updContenido(2, i, "p_corte_2", "col_p_corte_2", (resp) => { contenido[i] = resp })
                updContenido(1, i, "p_corte_1", "col_p_corte_1", (resp) => { contenido[i] = resp })
            }


            let Content = {
                uId: cookie[1],
                campos: contenido,
            }

            Post(`${Url}updInstitucion`, Content, (resp) => {

                mensaje = [{
                    status: "info",
                    mensaje: "Se han actualizado correctamente los datos de la Institución"
                }];
                
                respuesta([states, mensaje, errores, nameErr])
            });
        });
    }else{
        respuesta([states, mensaje, errores, nameErr])
    }
}


// WEBPACK FOOTER //
// ./src/funciones/PreferenciasFunction.jsx